import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ActivatedRouteSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { LorenPasswordResetToken } from "../interfaces/loren-password-reset-token.interface";
import { LorenAuthenticationEndpointsService } from "../../../shared/services/loren-authentication-service/loren-authentication-endpoints.service";

@Injectable()
export class LorenPasswordResetTokenResolver
  
{
  private lorenAuthenticationEndpointsService = inject(LorenAuthenticationEndpointsService);
  private http = inject(HttpClient);


  resolve(route: ActivatedRouteSnapshot): Observable<LorenPasswordResetToken> {
    const resetToken: LorenPasswordResetToken = {
      token: route.params.token,
      valid: false,
    };

    return this.http
      .get(
        this.lorenAuthenticationEndpointsService.forgottenPasswordTokenCheck(
          route.params.token
        )
      )
      .pipe(
        map(() => {
          resetToken.valid = true;
          return resetToken;
        }),
        catchError(() => {
          return of(resetToken);
        })
      );
  }
}
